import { Entity, RELATION_DEPENDS_ON } from '@backstage/catalog-model';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';

function isComponent(entity: Entity): boolean {
  return entity.kind.toLocaleLowerCase('en-US') === 'component';
}

/** A component that depends on at least one Resource. */
export function hasInfrastructure(entity: Entity): boolean {
  return (
    isComponent(entity) &&
    (entity.relations ?? []).some(
      relation =>
        relation.type === RELATION_DEPENDS_ON &&
        relation.targetRef.toLocaleLowerCase('en-US').startsWith('resource:'),
    )
  );
}

/**
 * The Infraestrutura card of the component overview (v2). The id stays
 * `byx-infra`: it replaces the previous card instead of adding a second one.
 */
export const entityInfraCard = EntityCardBlueprint.make({
  name: 'byx-infra',
  params: {
    filter: isComponent,
    type: 'content',
    loader: () => import('./InfraCard').then(m => <m.InfraCard />),
  },
});

/** The Infraestrutura tab: the same table, full width. */
export const entityInfraContent = EntityContentBlueprint.make({
  name: 'byx-infra',
  params: {
    path: '/infrastructure',
    // Fallback only (code O9): the blueprint needs a plain string, and it
    // shows only where the v2 group label is absent. The visible label comes
    // from byxTranslationRef (`entity.tabs.infrastructure`).
    title: 'Infraestrutura',
    group: 'infrastructure',
    filter: hasInfrastructure,
    loader: () => import('./InfraCard').then(m => <m.InfraContent />),
  },
});

export const infraModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [entityInfraCard, entityInfraContent],
});
